<template>
    <div>
        <hts-drawer
            ref="drawer"
            v-model="visible"
            :title="priceDetail && priceDetail.type ? (priceDetail.type === 'internal' ? $t('labels.viewPriceInternal') : $t('labels.viewPriceVendor')) : ''"
            :size="80"
            @close="close">
            <div>
                <price-information
                    v-if="visible"
                    :p-price-detail="priceDetail"
                    :p-price-offline-fee="priceOfflineFee" />
            </div>
        </hts-drawer>
    </div>
</template>

<script setup lang="ts">
import { ISearchPriceDetail } from '../quote-request/-components/ignore/imports/form'
import PriceInformation from './price-information.vue'

const { $formatters } = useNuxtApp()
const { $disableReactive } = useNuxtApp()

const priceDetail = ref<ISearchPriceDetail>()
const priceOfflineFee = ref<Array<ISearchPriceDetail>>()

const visible = ref(false)
const close = () => {
  visible.value = false
}

const open = (vPriceDetail: ISearchPriceDetail, vPriceOfflineFee: Array<ISearchPriceDetail>) => {
  priceDetail.value = $disableReactive(vPriceDetail)
  priceOfflineFee.value = $disableReactive(vPriceOfflineFee)
  visible.value = true
  if (priceDetail.value && priceDetail.value.type === 'internal') {
    totalItemsPrices.value = $disableReactive([priceDetail.value]).concat(priceOfflineFee.value)
  } else {
    totalItemsPrices.value = $disableReactive([priceDetail.value])
  }
}

const totalItemsPrices = ref()

defineExpose({
  open
})
</script>
